import { render, staticRenderFns } from "./SceneMatch.vue?vue&type=template&id=5165e7e2&scoped=true&"
import script from "./SceneMatch.vue?vue&type=script&lang=js&"
export * from "./SceneMatch.vue?vue&type=script&lang=js&"
import style0 from "./SceneMatch.vue?vue&type=style&index=0&id=5165e7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5165e7e2",
  null
  
)

export default component.exports